import { getEnv } from '@/utils/env';

const BrandliveLogo: React.FC<unknown> = () => {
  const { VITE_ASSET_SERVER } = getEnv();
  return <img src={`${VITE_ASSET_SERVER}/bl-platform/images/brandlive-chrome-cropped.png`} alt="BrandLive Logo" />;
};

export default BrandliveLogo;
